/* © ИП Коробкин И.Н., KIN DIGITAL CRM+ */
/**
 * Права доступа (раздел 12 ТЗ). Право вида "<ресурс>.<действие>".
 * Право "scope.all" снимает ограничение «только свои записи».
 */
export const PERMISSIONS = [
  'party.read', 'party.write', 'party.delete', 'party.import', 'party.merge',
  'deal.read', 'deal.write', 'deal.delete',
  'contract.read', 'contract.write', 'contract.delete', 'contract.finance',
  'expense.read', 'expense.write', 'expense.approve',
  'matter.read', 'matter.write', 'matter.delete',
  'task.read', 'task.write',
  'document.read', 'document.write', 'document.delete',
  'report.read',
  'debt.read', 'debt.write',
  'bankruptcy.read', 'bankruptcy.write',
  'writ.read', 'writ.write',
  'time.write', 'invoice.manage',
  'template.manage', 'calendar.manage',
  'dictionary.write',
  'user.manage', 'license.manage', 'audit.read',
  'scope.all',
] as const;
export type Permission = (typeof PERMISSIONS)[number];

const ALL = [...PERMISSIONS];

export interface RoleTemplate { code: string; name: string; permissions: Permission[] }

export const SYSTEM_ROLES: RoleTemplate[] = [
  { code: 'owner', name: 'Владелец / администратор', permissions: ALL },
  {
    code: 'head', name: 'Руководитель отдела',
    permissions: ['debt.read', 'debt.write', 'bankruptcy.read', 'bankruptcy.write', 'writ.read', 'writ.write', 'time.write', 'invoice.manage', 'template.manage', 'party.read', 'party.write', 'party.import', 'party.merge', 'deal.read', 'deal.write', 'contract.read', 'contract.write', 'contract.finance',
      'expense.read', 'expense.write', 'expense.approve', 'matter.read', 'matter.write', 'task.read', 'task.write', 'document.read', 'document.write',
      'report.read',
  'debt.read', 'debt.write',
  'bankruptcy.read', 'bankruptcy.write',
  'writ.read', 'writ.write',
  'time.write', 'invoice.manage',
  'template.manage', 'calendar.manage', 'scope.all'],
  },
  {
    code: 'lawyer', name: 'Юрист / адвокат',
    permissions: ['debt.read', 'debt.write', 'bankruptcy.read', 'writ.read', 'writ.write', 'time.write', 'party.read', 'party.write', 'deal.read', 'contract.read', 'expense.read', 'expense.write', 'matter.read', 'matter.write', 'task.read', 'task.write',
      'document.read', 'document.write'],
  },
  {
    code: 'trustee', name: 'Арбитражный управляющий',
    permissions: ['debt.read', 'debt.write', 'bankruptcy.read', 'bankruptcy.write', 'writ.read', 'writ.write', 'time.write', 'template.manage', 'party.read', 'party.write', 'contract.read', 'expense.read', 'expense.write', 'expense.approve', 'matter.read', 'matter.write', 'task.read', 'task.write',
      'document.read', 'document.write', 'report.read'],
  },
  {
    code: 'assistant', name: 'Помощник АУ / юриста',
    permissions: ['debt.read', 'bankruptcy.read', 'bankruptcy.write', 'writ.read', 'time.write', 'party.read', 'party.write', 'matter.read', 'task.read', 'task.write', 'document.read', 'document.write', 'expense.read', 'expense.write'],
  },
  {
    code: 'sales', name: 'Менеджер продаж',
    permissions: ['time.write', 'party.read', 'party.write', 'party.import', 'deal.read', 'deal.write', 'contract.read', 'contract.write', 'task.read', 'task.write', 'document.read', 'document.write'],
  },
  {
    code: 'collector', name: 'Оператор взыскания',
    permissions: ['debt.read', 'debt.write', 'writ.read', 'writ.write', 'time.write', 'party.read', 'party.write', 'matter.read', 'task.read', 'task.write', 'document.read'],
  },
  {
    code: 'accountant', name: 'Бухгалтер',
    permissions: ['debt.read', 'writ.read', 'invoice.manage', 'party.read', 'contract.read', 'contract.finance', 'expense.read', 'expense.write', 'expense.approve', 'report.read', 'scope.all'],
  },
];
